import { Controller } from "@hotwired/stimulus";
import { FetchRequest } from "@rails/request.js";
import Sortable from "sortablejs";

export default class extends Controller {
  static targets = ["position"];
  static values = { handle: { type: String, default: ".drag-handle" } };
  connect() {
    new Sortable(this.element, {
      handle: this.handleValue,
      // Mouse-event mode rather than native HTML5 DnD: cross-browser
      // consistent and the only path that headless Chrome / Cuprite can
      // drive in tests.
      forceFallback: true,
      // Rows that name their group (e.g. an invoice line's organization) stay
      // within it: the invoice prints lines grouped that way.
      onMove: ({ dragged, related }) =>
        !("groupId" in dragged.dataset && "groupId" in related.dataset) ||
        dragged.dataset.groupId === related.dataset.groupId,
      onEnd: () => {
        this.renumberPositions();
        this.sendPositions();
      },
    });
  }

  renumberPositions() {
    this.positionTargets.forEach((input, index) => (input.value = index + 1));
  }

  sendPositions() {
    const path = this.data.get("path");
    const list = Array.from(this.element.querySelectorAll("[data-position]")).map((e) => e.id);
    if (path) {
      const request = new FetchRequest("POST", path, {
        body: { sortOrder: list },
      });
      request.perform(); // fire and forget, no need to await a response.
    }
  }
}
